import { createFeatureSelector } from '@ngrx/store';
import { AutoRedemptionSettingsState } from './auto-redemption-settings.reducer';

export const getAutoRedemptionSettingsFeatureState =
  createFeatureSelector<AutoRedemptionSettingsState>('autoRedemptionSettings');
